"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var ActionTypes = _interopRequireWildcard(require("./action-types"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = function _default(state, action) {
  switch (action.type) {
    case ActionTypes.SUBSCRIBE_TO_FEATURE:
      // don't overwrite state if we already have it
      return state[action.payload.featureId] ? state : _objectSpread({}, state, _defineProperty({}, action.payload.featureId, {
        currentUpdateId: "INITIAL_FETCH"
      }));

    case ActionTypes.UNSUBSCRIBE_FROM_FEATURE:
      return Object.keys(state).filter(function (featureId) {
        return featureId !== action.payload.featureId;
      }).reduce(function (acc, featureId) {
        return _objectSpread({}, acc, _defineProperty({}, featureId, state[featureId]));
      }, {});

    case ActionTypes.FEATURES_FROM_SERVER:
      var features = action.payload.features; // take the features from the server and reduce them into state

      return _objectSpread({}, state, Object.keys(features) // if we are no longer listening then let's not include that feature
      .filter(function (featureId) {
        return Object.keys(state).indexOf(featureId) > -1;
      }).reduce(function (acc, featureId) {
        return _objectSpread({}, acc, _defineProperty({}, featureId, features[featureId]));
      }, {}));

    default:
      return state;
  }
};

exports.default = _default;